// @flow

import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';
import type Product from '../../../Product';
import { generateProduct } from '../../helpers';

export default class AddBundleToCart extends DataLayerEvent {
  /**
   * @inheritDoc
   */
  validate(): boolean {
    return JSON.parse(this.element.dataset.eventData).hasOwnProperty('products');
  }

  /**
   * @inheritDoc
   */
  dispatch(): void {
    super.dispatch();
    this.push({
      event: EventNames.ADD_TO_CART,
      ecommerce: {
        add_to_cart_location: this.data.location,
        items: JSON.parse(this.element.dataset.eventData).products.map((product: Product) => generateProduct(product))
      }
    });
  }
}
